import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { SITE } from '../constants/site';

const links = [
  { href: '#hero', label: 'Home' },
  { href: '#services', label: 'Services' },
  { href: '#store-info', label: 'Visit us' },
  { href: '#contact-us', label: 'Contact' },
];

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById('hero');
      const heroHeight = heroSection ? heroSection.offsetHeight : 0;

      if (window.scrollY > heroHeight - 48) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const barStyles = isScrolled || isOpen
    ? 'border-b border-slate-200/80 bg-white/95 shadow-card backdrop-blur-md'
    : 'border-b border-white/10 bg-transparent';

  const linkClass =
    'rounded-lg px-3 py-2 text-base font-medium text-slate-600 transition-colors hover:bg-optical-50 hover:text-optical-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-optical-500 focus-visible:ring-offset-2 md:text-slate-700';

  const linkClassOnHero =
    'rounded-lg px-3 py-2 text-base font-medium text-white/90 transition-colors hover:bg-white/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900/50 md:text-white/95';

  const activeLink = isScrolled || isOpen ? linkClass : linkClassOnHero;

  return (
    <nav
      className={`fixed top-0 z-50 w-full transition-colors duration-300 ${barStyles}`}
      aria-label="Primary"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <a
          href="#hero"
          className={`font-display text-xl font-semibold tracking-tight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-optical-500 focus-visible:ring-offset-2 md:text-2xl ${
            isScrolled || isOpen ? 'text-slate-900' : 'text-white drop-shadow-sm'
          }`}
        >
          {SITE.businessName}
        </a>

        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className={`flex min-h-[44px] min-w-[44px] items-center justify-center rounded-xl md:hidden ${
            isScrolled || isOpen
              ? 'text-slate-800 hover:bg-slate-100'
              : 'text-white hover:bg-white/10'
          } focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-optical-500 focus-visible:ring-offset-2`}
          aria-expanded={isOpen}
          aria-controls="mobile-menu"
        >
          <span className="sr-only">{isOpen ? 'Close menu' : 'Open menu'}</span>
          {isOpen ? <FaTimes className="text-2xl" aria-hidden /> : <FaBars className="text-2xl" aria-hidden />}
        </button>

        <ul className="hidden list-none items-center gap-1 md:flex">
          {links.map(({ href, label }) => (
            <li key={href}>
              <a href={href} className={activeLink}>
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Mobile drawer: hidden when closed so two max-height utilities never conflict (fixed tall white panel bug). */}
      <div
        id="mobile-menu"
        aria-hidden={!isOpen}
        className={
          isOpen
            ? `md:hidden border-t border-slate-100 bg-white shadow-[0_12px_24px_-12px_rgba(15,23,42,0.12)] max-h-[85vh] overflow-y-auto overscroll-contain`
            : 'hidden md:hidden'
        }
      >
        <ul className="flex flex-col gap-1 px-4 py-6">
          {links.map(({ href, label }) => (
            <li key={href}>
              <a
                href={href}
                tabIndex={isOpen ? 0 : -1}
                className="block rounded-xl px-4 py-3 text-lg font-medium text-slate-800 transition-colors hover:bg-optical-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-optical-500 focus-visible:ring-offset-2"
                onClick={() => setIsOpen(false)}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
